import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSModal, DSTextArea } from '@repo/design-system/index'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useHighlightErrorReport, useMetricErrorReport } from '../../../../../../../modules/apis/webview/caf'
import useHtmlParserTransform from '../../../../../../../modules/hooks/webview/caf/common/useHtmlParserTransform'
import { s_review } from '../../../../../../../modules/i18n/strings/auto/wording'
import { s_caf } from '../../../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../../../modules/i18n/useTranslation'

type ReportType = 'highlight' | 'metric'
interface Props {
  content: any
  type: ReportType
  isShowEditPopup: boolean
  setShowEditPopup: any
  id: number
}
const ErrorReportPopupComponent = ({ id, content, type, isShowEditPopup, setShowEditPopup }: Props) => {
  const { transformHTMLNode } = useHtmlParserTransform()
  const { t } = useTranslation()
  const router = useRouter()
  const { highlightId, metricId } = router.query
  const [value, setValue] = useState('')
  const { mutate: reportHighlightError } = useHighlightErrorReport()
  const { mutate: reportMetricError } = useMetricErrorReport()
  const report = () => {
    if (type === 'highlight') {
      reportHighlightError({ id: id, content: value || '' })
    } else if (type === 'metric') {
      reportMetricError({ id: id, content: value || '' })
    }
    setShowEditPopup(false)
  }

  useEffect(() => {
    setValue('')
  }, [content])

  return (
    <DSModal id="CafHighlightEditPopup" isOpen={isShowEditPopup} setIsOpen={setShowEditPopup} size="lg">
      <DSModal.Title>{t(s_caf.highlight.report)}</DSModal.Title>
      <DSModal.Content className="overflow-y-scroll">
        <div className="text-[16px] text-gray-700">{t(s_caf.highlight.report_sentence)}</div>
        <div className="keep-all mt-[12px] bg-gray-50 p-[8px]">
          {ReactHtmlParser(content, { transform: transformHTMLNode })}
        </div>
        <div className="mt-[12px]">
          <DSTextArea
            name={'self_intro'}
            placeholder={t(s_caf.highlight.report_content)}
            setValue={setValue}
            value={value}
          />
        </div>
      </DSModal.Content>

      <DSModal.ButtonContainer direction="horizontal" classNameFromProps="w-full mt-[57px]">
        <DSButton size={BUTTON_SIZE.MD} onClick={() => setShowEditPopup(false)} type={BUTTON_TYPE.OUTLINE}>
          <DSButton.Label className="whitespace-nowrap">{t(s_caf.statistic.bottomsheet_cancel)}</DSButton.Label>
        </DSButton>
        <DSButton size={BUTTON_SIZE.MD} onClick={report} disabled={value.length === 0}>
          <DSButton.Label className="whitespace-nowrap">{t(s_review.submit)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}

export default ErrorReportPopupComponent
